// 기본 설정값
export interface SeatDefaults {
  columns: string[];
  maxRows: number;
  activeSeats: string[];
  maleOnlySeats: string[];
  partnerGroups: string[][];
  male: string[];
  female: string[];
}

export const DEFAULTS: SeatDefaults = {
  columns: ['A', 'B', 'C', 'D'],
  maxRows: 5,
  activeSeats: ['A1','A2','A3','A4','A5','B1','B2','B3','B4','B5','C1','C2','C3','C4','C5','D1','D2','D3','D4','D5'],
  maleOnlySeats: [],
  partnerGroups: [],
  male: [],
  female: []
};
